import React from 'react';
import { TextField } from '@mui/material';

interface EventCommentProps {
  comment: string;
  onCommentChange: (value: string) => void;
}

export function EventComment(props: EventCommentProps) {
  const { comment, onCommentChange } = props;

  return (
    <TextField
      label="Kommentar"
      value={comment}
      onChange={eventValue => onCommentChange(eventValue.target.value)}
      margin="normal"
      fullWidth
      multiline
      minRows={3}
    />
  );
}
